import { render, staticRenderFns } from "./TravelInit.vue?vue&type=template&id=32552fbb&"
import script from "./TravelInit.vue?vue&type=script&lang=ts&"
export * from "./TravelInit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports